<template>
    <div class="detail-header d-flex">
        <div class="detail-header__left" @click="goBack">
            <img class="detail-header__img" src="@/assets/mobile-imgs/detail-back.png" />
        </div>
        <div class="detail-header__center">{{ content }}</div>
        <div class="detail-header__right"></div>
    </div>
</template>

<script>
import MobileContainer from './mobile-container';
import MobileHeader from './mobile-header';

export default {
    name: 'DetailHeader',

    props: {
        content: {
            type: String,
            default: '详情'
        }
    },

    methods: {
        goBack() {
            this.$router.back();
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-header {
    background: #2d2d2d;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 9;
    height: 60px;
    &__left {
        position: absolute;
        left: 20px;
        top: 19px;
    }
    &__img {
        width: 24px;
        height: 24px;
    }
    &__center {
        width: 100vw;
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        line-height: 60px;
    }
}
</style>
